$(document).ready(function () {
  if ($('.parallax_text').length) {
    var object = $('.parallax_text')
    var objectPosrition = $('.parallax_text').offset().top
    var layer = object.closest('section')

    layer.mousemove(function (event) {
      var valueX1 = (event.pageX * -1) / 20,
        valueX2 = (event.pageX * -1) / 25,
        valueX3 = (event.pageX * -1) / 35,
        valueX4 = (event.pageX * -1) / 30,
        valueY = ((event.pageY - objectPosrition) * -1) / 20

      object.find('.string_1, .string_2, .string_7').css({
        transform: 'translate3d(' + valueX1 + 'px,' + valueY + 'px,0)',
      })
      object.find('.string_3, .string_4').css({
        transform: 'translate3d(' + valueX2 + 'px,' + valueY + 'px,0)',
      })
      object.find('.parallax_text__main').css({
        transform: 'translate3d(' + valueX3 + 'px,' + valueY + 'px,0)',
      })
      object.find('.string_5, .string_6').css({
        transform: 'translate3d(' + valueX4 + 'px,' + valueY + 'px,0)',
      })
    })
  }
})
